"use client"

import { useRouter } from 'next/navigation'

const memo = {}

// Adres powrotu po logowaniu także w sessionStorage: logowanie przez Google i Facebook
// oraz przejście między routerami przeładowują stronę i czyszczą pamięć modułu.
const STORAGE_KEY = 'spl:powrot'
const STORAGE_TTL = 30 * 60 * 1000

const hasControlChars = (s) => {
    for (let i = 0; i < s.length; i++) {
        const c = s.charCodeAt(i)
        if (c < 32 || c === 127) return true
    }
    return false
}

const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN

// Ścieżka w obrębie serwisu („/…”, bez „//”, „/\” i znaków sterujących) albo pełny adres wizytówki na subdomenie
// serwisu (ten sam protokół); inaczej null.
export function safeReturnPath (value) {
    if (typeof value !== 'string' || !value || value.length > 2000 || hasControlChars(value)) return null
    if (typeof window === 'undefined') return /^\/(?![/\\])/.test(value) ? value : null
    try {
        const url = new URL(value, window.location.origin)
        if (DOMAIN && url.origin !== window.location.origin && url.protocol === window.location.protocol && url.host.endsWith(`.${DOMAIN}`) && !url.username && !url.password) return url.href
        if (url.origin !== window.location.origin) return null
        const path = url.pathname + url.search + url.hash
        return /^\/(?![/\\])/.test(path) ? path : null
    } catch (err) {
        return null
    }
}

function storeReturnPath (value) {
    const path = safeReturnPath(value)
    if (!path) return
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path, at: Date.now() })) } catch (err) { /* brak dostępu: zostaje pamięć modułu */ }
}

// Odczyt jednorazowy; wynik zostaje w pamięci modułu na kolejne rendery.
function takeStoredReturnPath () {
    if (typeof window === 'undefined') return null
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY)
        sessionStorage.removeItem(STORAGE_KEY)
        const data = raw && JSON.parse(raw)
        if (data && Date.now() - data.at < STORAGE_TTL) return safeReturnPath(data.path)
    } catch (err) { /* uszkodzony wpis albo brak dostępu */ }
    return null
}

const useRedirectBack = () => {
    const router = useRouter()

    const setRedirectPath = (path) => {
        memo.previousPath = path || window.location.href || '/'
        storeReturnPath(memo.previousPath)
    }

    const redirect = (explicitPath, backPath, memoFallbackPath) => {
        if (!explicitPath) {
            const stored = takeStoredReturnPath()
            if (stored && !memo.previousPath) memo.previousPath = stored
        }
        const path = explicitPath || memo.previousPath || memoFallbackPath
        if (backPath) setRedirectPath(backPath)
        if (typeof window !== 'undefined') {
            if (path) {
                // wizytówka na subdomenie: pełne przejście
                if (/^https?:\/\//.test(path)) window.location.assign(path)
                else router.push(path)
            } else {
                router.back()
            }
        }

        return null
    }

    const reload = () => router.refresh()

    return [redirect, setRedirectPath, reload]
}

export default useRedirectBack
